import { render, staticRenderFns } from "./OracleZjjhbModal.vue?vue&type=template&id=2b6ca0b5&"
import script from "./OracleZjjhbModal.vue?vue&type=script&lang=js&"
export * from "./OracleZjjhbModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports